export enum UserRolesEnum {
  DealerAdmin = 'Dealer admin',
  DealerUser = 'Dealer user',
  SuperAdmin = 'Super admin',
  SalesRepresentative = 'Sales rep',
  CustomerSalesRepresentative = 'CSR',
}
